/**
 * EmptyStateAddBusiness — estado vacío para búsquedas sin resultados.
 *
 * Muestra 2 CTAs: "Añadir mi negocio" (autoalta) y "Sugerir negocio" (rápido).
 */
import { useState } from "react";
import { Link } from "react-router-dom";
import { Storefront, Plus, MapPin } from "@phosphor-icons/react";
import SuggestBusinessModal from "./SuggestBusinessModal";

export default function EmptyStateAddBusiness({ query = "", city = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="ag-card p-10 text-center" data-testid="empty-state-add">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[var(--ag-gold)]/10 border border-[var(--ag-gold)]/30 mb-5">
          <Storefront size={26} weight="duotone" className="text-[var(--ag-gold)]" />
        </div>
        <h3 className="font-display text-2xl font-bold tracking-tighter">
          {query ? `No encontramos «${query}»` : "Sin resultados"}
          {city && <span className="text-[var(--ag-text-dim)]"> en {city}</span>}
        </h3>
        <p className="text-[var(--ag-text-dim)] text-sm mt-3 max-w-md mx-auto">
          ¿Eres el dueño de un negocio del motor que no aparece, o conoces uno que falta?
          Ayúdanos a completar el directorio.
        </p>
        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/anadir-negocio"
            className="ag-btn-gold inline-flex items-center gap-2 px-5 py-2.5 text-xs uppercase tracking-wider font-semibold"
            data-testid="empty-cta-add">
            <Plus size={13} weight="bold" /> Añadir mi negocio
          </Link>
          <button onClick={() => setOpen(true)}
            className="inline-flex items-center gap-2 px-5 py-2.5 text-xs uppercase tracking-wider font-semibold text-[var(--ag-text)] border border-[var(--ag-border)] rounded-sm hover:border-[var(--ag-gold)]/60 transition-colors"
            data-testid="empty-cta-suggest">
            <MapPin size={13} /> Sugerir negocio
          </button>
        </div>
        <p className="text-[10px] text-[var(--ag-text-dim)] mt-5">
          Añadir tu negocio · <strong>gratis 30 días</strong> · sin tarjeta · sin compromiso.
        </p>
      </div>
      {open && <SuggestBusinessModal onClose={() => setOpen(false)} defaultCity={city} />}
    </>
  );
}
